<template>
  <div class="editor-quote__parent-flex">
    <div
      class="editor-quote__wrapper editor-wrapper text-container"
      :class="{ editable }"
    >
      <div class="editor-quote__content-body">
        <div class="quote-img__wrapper">
          <SvgIcon name="quotes" class="quote-img" />
        </div>

        <div ref="hiddenTextRef" class="editor-quote__content-text-hidden">
          {{ hiddenText }}
        </div>

        <EditorContentEditable
          tag="blockquote"
          class="editor-quote__content-text"
          :class="{ overflow: isTextOverflow }"
          :contenteditable="editing"
          placeholder="Текст цитаты"
          :text="text"
          @input="handleTextInput"
        >
        </EditorContentEditable>

        <EditorContentEditable
          tag="p"
          class="editor-quote__content-author"
          placeholder="Автор"
          :contenteditable="editing"
          :text="author"
          @input="handleAuthorInput"
        ></EditorContentEditable>

        <div
          v-if="localSource || editing"
          class="editor-quote__content-source-wrapper"
        >
          <span>Источник:</span
          ><EditorContentEditable
            tag="span"
            class="editor-quote__content-source"
            placeholder="ссылка на источник"
            :contenteditable="editing"
            :text="source"
            @input="handleSourceInput"
          >
          </EditorContentEditable>
        </div>
      </div>

      <EditorQuoteBlockEdit
        v-if="editable"
        :editing="editing"
        class="main-quote-edit"
        @edit="editing = true"
        @save="handleAccept"
        @delete="handleDelete"
      />
    </div>
  </div>
</template>

<script setup>
const MAX_HEIGHT = 168;

const props = defineProps({
  editable: { type: Boolean, default: false },
  text: { type: [String, Number], default: '' },
  author: { type: [String, Number], default: '' },
  source: { type: [String, Number], default: '' },
});

const editing = ref(props.editable);
const localAuthor = ref('');
const localSource = ref('');
const localText = ref('');
const hiddenText = ref('');
const isTextOverflow = ref(false);
const hiddenTextRef = ref(null);

watch(
  () => props.text,
  (value) => {
    localText.value = value;
  },
);

watch(
  () => props.author,
  (value) => {
    localAuthor.value = value;
  },
);

watch(
  () => props.source,
  (value) => {
    localSource.value = value;
  },
);

onMounted(() => {
  matchHeight();
  localText.value = props.text;
  hiddenText.value = props.text;
  localAuthor.value = props.author;
  localSource.value = props.source;
});

const matchHeight = () => {
  return setTimeout(
    () =>
      (isTextOverflow.value =
        hiddenTextRef.value?.getBoundingClientRect().height > MAX_HEIGHT),
  );
};

const handleTextInput = (e) => {
  localText.value = e.target.innerText;
  hiddenText.value = e.target.innerText;
  matchHeight();
};

const handleAuthorInput = (e) => {
  localAuthor.value = e.target.innerText;
};

const handleSourceInput = (e) => {
  localSource.value = e.target.innerText;
};

const handleAccept = () => {
  if (localText.value === '') {
    emit('error', 'Заполните текст цитаты');
    return;
  }

  const data = {
    text: localText.value,
    author: localAuthor.value,
    source: localSource.value,
  };

  emit('change', data);
  editing.value = false;
};

const handleDelete = () => {
  emit('delete');
};
</script>
